import { Injectable } from '@angular/core';
import { DomainEntityBase, DomainEntityType } from '@models';
import { EntityServicesBase, EntityServicesElements } from '@ngrx/data';
import { DataCollectionService } from '../collection.service';

@Injectable()
export class AppEntityService extends EntityServicesBase {
  constructor(elements: EntityServicesElements) {
    super(elements);
  }

  override getEntityCollectionService<T extends DomainEntityBase>(
    entityName: string
  ): DataCollectionService<T> {
    return super.getEntityCollectionService<T>(
      entityName
    ) as DataCollectionService<T>;
  }

  isServiceLoaded(entityName: DomainEntityType): boolean {
    return !!this['EntityCollectionServices'][entityName];
  }
}
